import { Injectable } from '@angular/core';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  static getValidatorErrorMessage(nameInput: string, validatorName: string, validatorValue?: any) {
    const config = {
      required: `El campo ${nameInput} es requerido`,
      email: `El campo ${nameInput} debe ser un email válido`,
      invalidNumber: `El campo ${nameInput} debe ser un número`,
      invalidPassword: `El campo ${nameInput} debe contener al menos 6 caracteres y al menos un número`,
      minlength: `El campo ${nameInput} debe tener al menos ${validatorValue.requiredLength} caracteres`,
      mustMatchInvalid: `El capo ${nameInput} no coincide con el campo contraseña`,
    };
    return config[validatorName];
  }

  static passwordValidator(control) {
    // {6,20}           - Assert password is between 6 and 20 characters
    // (?=.*[0-9])       - Assert a string has at least one number
    if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,20}$/)) {
      return null;
    } else {
      return {invalidPassword: true};
    }
  }

  static isNumberValidator(control) {
    if (control.value === null) return {invalidNumber: true};
    return control.value.toString().match('^\\d*$') ? null : {invalidNumber: true};
  }

  static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return {mustMatchInvalid: true};
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({mustMatchInvalid: true});
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
